<template>
    <div>
        Page not found
    </div>
</template>

<script setup>

</script>

<style scoped>

</style>